import { render, staticRenderFns } from "./Recorrido.vue?vue&type=template&id=577d7134&scoped=true&"
import script from "./Recorrido.vue?vue&type=script&lang=ts&"
export * from "./Recorrido.vue?vue&type=script&lang=ts&"
import style0 from "./Recorrido.vue?vue&type=style&index=0&id=577d7134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d7134",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
